import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteCategory = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await api.delete(`/categories/${id}`)
      return response.data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Categories] })
    },
  })
}
